import { AwsRum, type AwsRumConfig } from "aws-rum-web";

let awsRum: AwsRum | null = null;

export function initRum(): AwsRum | null {
  if (!process.env.REACT_APP_RUM_APPLICATION_ID) {
    return null;
  }

  try {
    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      identityPoolId: process.env.REACT_APP_RUM_IDENTITY_POOL_ID!,
      endpoint: `https://dataplane.rum.${process.env.REACT_APP_RUM_APPLICATION_REGION}.amazonaws.com`,
      telemetries: ["http", "errors", "performance"],
      allowCookies: true,
      enableXRay: true,
      signing: true
    };

    awsRum = new AwsRum(
      process.env.REACT_APP_RUM_APPLICATION_ID,
      process.env.REACT_APP_RUM_APPLICATION_VERSION || "1.0.0",
      process.env.REACT_APP_RUM_APPLICATION_REGION || "eu-west-3",
      config
    );

    return awsRum;
  } catch (error) {
    return null;
  }
}

export function recordPageView(pageId: string): void {
  if (awsRum) {
    awsRum.recordPageView(pageId);
  }
}

export function getAwsRum(): AwsRum | null {
  return awsRum;
}

export function setRumRefAdeme(refAdeme: string): void {
  if (awsRum && refAdeme) {
    awsRum.addSessionAttributes({ ref_ademe: refAdeme });
  }
}

export function getRumSessionId(): string | null {
  if (!awsRum) {
    return null;
  }
  try {
    const session = (awsRum as any).getSession();
    return session?.sessionId || null;
  } catch {
    return null;
  }
}
